import * as React from "react";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
export class BaseballAnimation extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.container = React.createRef();
    }
    componentDidMount() {
        if (this.container.current) {
            gsap.from(this.container.current, {
                duration: 0.3,
                delay: 1,
                ease: "power2.inOut",
                scrollTo: {
                    x: "max"
                }
            });
        }
    }
    render() {
        return (React.createElement("div", { className: "rj-sport-scoreboard__live-baseball-animate-container", ref: this.container },
            React.createElement("div", { className: "rj-sport-scoreboard__live-baseball-container" }, this.props.children)));
    }
}
//# sourceMappingURL=BaseballAnimation.js.map